import {safeGet} from "../utils";

export function renderNavigatorFingerprint(): string {
  return [
    safeGet(() => navigator.cookieEnabled),
    safeGet(() => navigator.doNotTrack),
    safeGet(() => navigator.pdfViewerEnabled),
    safeGet(() => (navigator as any).platform),
    safeGet(() => (navigator as any).vendor),
  ].join('|');
}
